import { PRODUCT_AREA } from '@leagueplatform/analytics';
import { Box, StackLayout } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { Masonry } from '@leagueplatform/masonry';
import { useNavigate } from 'react-router-dom';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { useCommonPageSetup } from '@scfhp-web/shared-module';
import { HeroSection } from 'components/hero-section/hero-section.component';

export const FormStatusesPage: React.FC = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const title = formatMessage({ id: 'STR_SUBMITTED_REQUESTS' });

  useCommonPageSetup({ title, productArea: PRODUCT_AREA.GET_CARE });

  return (
    <MainPageContainer
      width="100%"
      css={{
        '.GDS-vertical-stack-layout': {
          width: '100%',
        },
      }}
    >
      <HeroSection
        title={title}
        goBack={() => {
          navigate(-1);
        }}
        height="154px"
      />

      <StackLayout
        orientation="vertical"
        horizontalAlignment="stretch"
        css={{
          width: '100%',
          maxWidth: '894px',
          margin: '0 auto',
          minHeight: 'calc(100vh - 300px)',
          'form .GDS-horizontal-stack-layout': {
            flexWrap: 'nowrap',
            overflowX: 'auto',
            justifyContent: 'flex-start',
            gap: '$one',
          },
          'form .GDS-horizontal-stack-layout > .GDS-stack-item': {
            flex: '0 0 auto',
            minWidth: 'max-content',
          },
          '[data-testid="contentBlock$formStatuses$noFormsEmptyContentBlock"] .GDS-heading-text':
            {
              width: '100%',
            },
          '.GDS-status-banner-title': {
            fontWeight: '400 !important',
          },
          '[data-testid="GDS-ComposableCardBody"] [data-testid="GDS-Tag"]': {
            borderRadius: '9999px',
            paddingInline: '10px',
            gap: '6px',
          },
        }}
      >
        {/* Position parent for Masonry's absolutely-positioned loading spinner. */}
        <Box
          css={{
            position: 'relative',
            width: '100%',
            minHeight: 'calc(100vh - 300px)',
          }}
        >
          <Masonry rootNodeId="formStatuses$rootWeb" />
        </Box>
      </StackLayout>
    </MainPageContainer>
  );
};
